import { Subject } from '../types/question';

// Mock data for development
const mockSubjects: Subject[] = [
  {
    id: 'science',
    name: 'Science',
    strands: [
      {
        id: 'human-body',
        name: 'Human Body',
        subjectId: 'science',
        substrands: [
          { id: 'heart', name: 'The Heart' },
          { id: 'lungs', name: 'The Lungs' },
          { id: 'digestive', name: 'Digestive System' }
        ]
      },
      {
        id: 'plants',
        name: 'Plants',
        subjectId: 'science',
        substrands: [
          { id: 'photosynthesis', name: 'Photosynthesis' },
          { id: 'growth', name: 'Plant Growth' }
        ]
      }
    ]
  },
  {
    id: 'mathematics',
    name: 'Mathematics',
    strands: [
      {
        id: 'numbers',
        name: 'Numbers',
        subjectId: 'mathematics',
        substrands: [
          { id: 'addition', name: 'Addition' },
          { id: 'subtraction', name: 'Subtraction' }
        ]
      }
    ]
  }
];

class CurriculumService {
  async getSubjects(): Promise<Subject[]> {
    try {
      // TODO: Replace with actual API call
      return mockSubjects;
    } catch (error) {
      console.error('Error fetching subjects:', error);
      throw new Error('Failed to fetch subjects');
    }
  }

  async getStrands(subjectId: string) {
    try {
      const subject = mockSubjects.find(s => s.id === subjectId);
      if (!subject) throw new Error('Subject not found');
      return subject.strands;
    } catch (error) {
      console.error('Error fetching strands:', error);
      throw new Error('Failed to fetch strands');
    }
  }

  async getSubstrands(subjectId: string, strandId: string) {
    try {
      const subject = mockSubjects.find(s => s.id === subjectId);
      if (!subject) throw new Error('Subject not found');
      if (!subject.strands) throw new Error('No strands found for subject');
      const strand = subject.strands.find(s => s.id === strandId);
      if (!strand) throw new Error('Strand not found');
      return strand.substrands;
    } catch (error) {
      console.error('Error fetching substrands:', error);
      throw new Error('Failed to fetch substrands');
    }
  }
}

export const curriculumService = new CurriculumService(); 